import { Injectable, Injector } from '@angular/core';

import { inject } from '@angular/core';
import {
  fetchAndActivate,
  getAll,
  getBoolean,
  getNumber,
  getString,
  getValue,
  isSupported as isRemoteConfigSupported,
  RemoteConfig,
  Value,
} from '@angular/fire/remote-config';

@Injectable({ providedIn: 'root' })
export class RemoteConfigService {
  private readonly injector = inject(Injector);
  private asyncRemoteConfig?: Promise<RemoteConfig | null>;
  private isAvailable = false;

  initiateConfig(): Promise<unknown> {
    const asyncRemoteConfig = isRemoteConfigSupported().then((supported: unknown) =>
      supported ? this.setRemoteConfig() : null,
    );
    this.asyncRemoteConfig = asyncRemoteConfig;
    return asyncRemoteConfig;
  }
  async setRemoteConfig(): Promise<RemoteConfig> {
    this.isAvailable = true;
    const remoteConfig = this.injector.get(RemoteConfig);
    remoteConfig.settings.minimumFetchIntervalMillis = 1 * 60 * 60 * 1000;
    await fetchAndActivate(remoteConfig);
    return remoteConfig;
  }

  /**
   * Get async remote config {@link Value} by key
   */
  public async getConfigValue(key: string): Promise<Value> {
    if (this.isAvailable) {
      return getValue((await this.asyncRemoteConfig) as RemoteConfig, key);
    }
    throw new Error('Remote Config Not initialized');
  }

  /**
   * Get async remote config boolean value by key
   */
  public async getBooleanValueByKey(key: string): Promise<boolean> {
    if (this.isAvailable) {
      return getBoolean((await this.asyncRemoteConfig) as RemoteConfig, key);
    }
    throw new Error('Remote Config Not initialized');
  }

  /**
   * Get async remote config number value by key
   */
  public async getNumberValueByKey(key: string): Promise<number> {
    if (this.isAvailable) {
      return getNumber((await this.asyncRemoteConfig) as RemoteConfig, key);
    }
    throw new Error('Remote Config Not initialized');
  }

  /**
   * Get async remote config string value by key
   */
  public async getStringValueByKey(key: string): Promise<string> {
    if (this.isAvailable) {
      return getString((await this.asyncRemoteConfig) as RemoteConfig, key);
    }
    throw new Error('Remote Config Not initialized');
  }

  /**
   * Get async all remote config value
   */
  public async getAllValueAsync(): Promise<Record<string, Value>> {
    if (await this.asyncRemoteConfig) {
      return getAll((await this.asyncRemoteConfig) as RemoteConfig);
    }
    throw new Error('Remote Config Not initialized');
  }
}

// @Injectable({ providedIn: 'root' })
// export class RemoteConfigService {
//   private readonly injector = inject(Injector);
//   private remoteConfigPromise?: Promise<RemoteConfig | null>;
//   private remoteConfig: RemoteConfig | null = null;
//   private isAvailable = false;

//   async initiateConfig(): Promise<unknown> {
//     return isRemoteConfigSupported().then((supported: unknown) => {
//       this.remoteConfig = supported ? this.injector.get(RemoteConfig) : null;
//       return fetchAndActivate(this.remoteConfig as RemoteConfig)
//     });
//   }
//   getAllValueSync(): Record<string, Value> {
//     return getAll(this.remoteConfig as RemoteConfig);
//   }
// constructor(private injector: Injector) {
//   // Initialize the promise once during service creation
//   this.remoteConfigPromise = isRemoteConfigSupported().then((supported: boolean) => {
//     this.isAvailable = supported;
//     if (supported) {
//       const remConf = this.injector.get(RemoteConfig);
//       remConf.settings.minimumFetchIntervalMillis = isDevMode() ? 10000 / 1000 : 43200000 / 1000; // 1 hour

//       return fetchAndActivate(remConf).then((isActivated) => {
//         console.log(
//           // 'The current call activated the fetched configs',
//           `${
//             isActivated
//               ? 'The current call activated the fetched configs'
//               : 'The fetched configs were already activated'
//           }`,
//           getAll(remConf)
//         );
//         return remConf;
//       });
//     } else {
//       return null;
//     }
//   });
// }

// async getRemoteConfig(): Promise<RemoteConfig | null> {
//   return this.remoteConfigPromise;
// }

// async initializeConfig(): Promise<boolean> {
//   try {
//     if (await isRemoteConfigSupported()) {
//       const result = await fetchAndActivate(inject(RemoteConfig));
//       console.log('Remote config fetched and activated', result);
//       return result;
//     } else {
//       console.log('Remote config not checked yet=> isRemoteConfigSupported', await isRemoteConfigSupported());
//     }
//   } catch (error) {
//     console.error('Error fetching remote config:', error);
//     return true;
//     //throw new Error('Error fetching remote config');
//   }
//   console.error('no Error outside remote config load:');
//   return false;
// }

//   public async getConfigValue(key: string): Promise<Value> {
//     return getValue(this.remoteConfig as RemoteConfig, key);
//     // if (this.isAvailable) {
//     // } else {
//     //   throw new Error('Remote Config Not initialized');
//     // }
//   }

//   public async getBooleanValueByKey(key: string): Promise<boolean> {
//     return getBoolean((await this.remoteConfigPromise) as RemoteConfig, key);
//     // if (this.isAvailable) {
//     // } else {
//     //   throw new Error('Remote Config Not initialized');
//     // }
//   }

//   /**
//    * Get remote config number value by key
//    */
//   public async getNumberValueByKey(key: string): Promise<number> {
//     return getNumber((await this.remoteConfigPromise) as RemoteConfig, key);
//     // if (this.isAvailable) {
//     // } else {
//     //   throw new Error('Remote Config Not initialized');
//     // }
//   }

//   /**
//    * Get remote config string value by key
//    */
//   public async getStringValueByKey(key: string): Promise<string> {
//     return getString((await this.remoteConfigPromise) as RemoteConfig, key);
//     // if (this.isAvailable) {
//     // } else {
//     //   throw new Error('Remote Config Not initialized');
//     // }
//   }

//   /**
//    * Get all remote config value
//    */
//   public async getAllValue(): Promise<Record<string, Value>> {
//     console.log('getAllValue', this.remoteConfigPromise, this.injector.get(RemoteConfig));
//     return getAll(this.remoteConfig as RemoteConfig);
//     // return (this.remoteConfigPromise as Promise<RemoteConfig>).then((remoteConfig) => {
//     //   return getAll(remoteConfig as RemoteConfig);
//     // });
//     // return getAll((await this.remoteConfigPromise) as RemoteConfig);
//     // if (this.isAvailable) {
//     // } else {
//     //   throw new Error('Remote Config Not initialized');
//     // }
//   }
// }

// import { Injectable, Injector, isDevMode } from '@angular/core';

// import { inject } from '@angular/core';
// import {
//   fetchAndActivate,
//   fetchConfig,
//   getAll,
//   getBoolean,
//   getNumber,
//   getString,
//   getValue,
//   isSupported as isRemoteConfigSupported,
//   RemoteConfig,
//   Value,
// } from '@angular/fire/remote-config';

// @Injectable({ providedIn: 'root' })
// export class RemoteConfigService {
//   private remoteConfig: RemoteConfig | null = null;
//   constructor(private injector: Injector) {
//     // Initialize the promise once during service creation
//     isRemoteConfigSupported().then((supported: boolean) =>
//       supported
//         ? ((this.remoteConfig = this.injector.get(RemoteConfig)),
//           (this.remoteConfig.settings.minimumFetchIntervalMillis = isDevMode() ? 10000 / 1000 : 43200000 / 1000)) // 1 hour
//         : null
//     );
//   }

//   async initializeConfig(): Promise<boolean> {
//     try {
//       if (this.remoteConfig) {
//         const result = await fetchAndActivate(inject(RemoteConfig));
//         console.log('Remote config fetched and activated', result);
//         return result;
//       } else {
//         console.log('Remote config not checked yet=> isRemoteConfigSupported', await isRemoteConfigSupported());
//       }
//     } catch (error) {
//       console.error('Error fetching remote config:', error);
//       return true;
//       //throw new Error('Error fetching remote config');
//     }
//     console.error('no Error outside remote config load:');
//     return false;
//   }

//   public getConfigValue(key: string): Value | null {
//     return this.remoteConfig ? getValue(this.remoteConfig, key) : null;
//   }

//   public getBooleanValueByKey(key: string): boolean | null {
//     return this.remoteConfig ? getBoolean(this.remoteConfig, key) : null;
//   }

//   /**
//    * Get remote config number value by key
//    */
//   public getNumberValueByKey(key: string): number | null {
//     return this.remoteConfig ? getNumber(this.remoteConfig, key) : null;
//   }

//   /**
//    * Get remote config string value by key
//    */
//   public getStringValueByKey(key: string): string | null {
//     return this.remoteConfig ? getString(this.remoteConfig, key) : null;
//   }

//   /**
//    * Get all remote config value
//    */
//   public getAllValue(): Record<string, Value> | null {
//     return this.remoteConfig ? getAll(this.remoteConfig) : null;
//   }
// }
